module.exports = __webpack_public_path__ + "img/wxcode.0894554e.jpg";